import { EnumInt, EnumString } from "../types";

export class CommonEnumService {

  private static tag: string = "CommonEnumService";
  
  /**
   *  @returns key-value-array with enum key and value
   *  works only if enum has !!!integer values
   *  f.e.:
   *  * _null = 1, User = 0, Manager = 2, Admin= 3
   *  * _null, User, Manager, Admin
   */
  public static mapEnumIntToArrayofEnumInts(enumObject: any): EnumInt[] {
    let enums: Object = enumObject;

    let result: EnumInt[] = [];
    let resultKeys: string[] = Object.keys(enums).filter((v) => isNaN(Number(v)) );
    let resultOrdinalValues: string[] = Object.values(enums).filter( (v) => !isNaN(Number(v)) );

    //let enumKeyValueArray = Object.keys(enumObject).map(key => ({ key, value: enumObject[key] }));

    resultKeys.map((value, idx) => {
      let item: EnumInt = {
        key: value,
        value: parseInt(resultOrdinalValues[idx]),
      };
      result.push(item);
    });

    return result;
  }

  public static mapEnumStringToArrayofEnumStrings(enumObject: any): EnumString[] {
    let enums: Object = enumObject;

    let result: EnumString[] = [];
    let resultKeys: string[] = Object.keys(enums).filter((v) => isNaN(Number(v)) );
    let values: string[] = Object.values(enums)

    //let enumKeyValueArray = Object.keys(enumObject).map(key => ({ key, value: enumObject[key] }));

    resultKeys.map((value, idx) => {
      let item: EnumString = {
        key: value,
        value: (values[idx]),
      };
      result.push(item);
    });

    return result;
  }


  public static mapEnumIntKeyToEnumValue(enums: Object, keyIn: string | null | undefined): number | null {
    //console.log(this.tag + "mapEnumIntKeyToEnumOrdinal() keyIn:" + keyIn);
    if (keyIn === null || keyIn === undefined) return null;
    let enumInts: EnumInt[] = this.mapEnumIntToArrayofEnumInts(enums);

    for (let idx: number = 0; idx <= enumInts.length - 1; idx++) {
      if (enumInts[idx].key.toLocaleLowerCase() === keyIn.toLocaleLowerCase()) {
        //console.log(this.tag + " " + keyIn + " " +enumInts[idx]);
        return enumInts[idx].value;
      } 
    }
 
    return null;

  }

  public static mapEnumIntValueToEnumKey(enums: Object, value: number | null | undefined): string | null {
    //console.log(this.tag + "mapEnumIntValueToEnumKey() value:" + value);
    if (value === null || value === undefined) return null;
    let enumInts: EnumInt[] = this.mapEnumIntToArrayofEnumInts(enums);

    for (let idx: number = 0; idx <= enumInts.length - 1; idx++) {
      if (enumInts[idx].value === value) {
        //console.log(this.tag + " " + value + " " +enumInts[idx]);
        return enumInts[idx].key;
      } 
    }

    return null;
  }
}
